module.exports = __webpack_public_path__ + "img/resource-energy.857e9c6d.png";